export const triggerPageVisitAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('configuratorProjects.visit');
};

export const triggerStartNewProjectAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('configuratorProjects.startNewProject');
};

export const triggerViewEstimateAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('configuratorProjects.viewEstimate');
};

export const triggerEditProjectAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('configuratorProjects.editProject');
};

export const triggerWhyThdInstallersAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('configuratorProjects.whyHomeDepotInstallersAccordionClick');
};